import { useLoaderData } from 'remix'
import { ArticleCafePage } from '~/components/modules/ArticleCafePage'
export const ArticlePage: React.VFC<ArticlePageProps> = ({ articleData }) => {
    const { article, shops } = articleData;

    return (
        <>
            <h1 className='articleTitle'>{article.article_title}</h1>

            <div className='articleContent'>
                <div className="articleImage">
                    <img src={article.article_image} alt="Article" width="355" height="237" />
                </div>
                <p>{article.article_description}</p>
            </div>

            <div className="nomadList10">
                <span>
                    <i className="fas fa-check"></i> 目次
                </span>
                <ul className="fa-check__list">
                    {shops.map((shop, index) => (
                        <li className="fa-check__box" key={index}>
                            <a href={`#${shop.shop_name}`}>{shop.shop_name}</a>
                        </li>
                    ))}
                </ul>
            </div>

            <h2 className='shop-intro'><b>{article.article_sub_title}</b></h2>

            <div className='articleShops'>
                {Array.isArray(shops) && shops.length > 0 ? shops.map((shop) => (
                    <ArticleCafePage key={shop.shop_id} shopData={shop} />
                )) : <p>データがありません</p>}
            </div>

            <p className='articleSummary'>{article.article_summary}</p>
        </>
    );
};